<template lang='pug'>
.modal-header
  .pull-right.actions
    i.fpui.fpui-remove(v-if='!hideClose', @click='close()', type='button')
    i(
      :class='[action.class, { disabled: action.disabled }]',
      @click='launchAction(action)',
      type='button',
      v-for='action, index in actions',
      :key='index'
    )
  h3.modal-title(v-if='title', v-html="title||' '")

</template>

<script>

export default {
  props: {
    title: { type: String },
    actions: { type: Array, default () { return [] } },
    hideClose: { type: Boolean, default: false }
  },
  methods: {
    launchAction (action) {
      if (action.disabled) return
      this.$emit(action.name)
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang='less'>
  @import "~@/shared/styles/_variables.less";

  .modal-header {
    position: relative;
    border-bottom: none;
    padding: 10px 15px;
    z-index: 1;
    h3 {
      width: 85%;
      font-weight: 400!important;
      margin: 0;
      line-height: 1.42857143;
    }
    i {
      cursor: pointer;
      border: none;
      background: transparent;
      color: @blue;
      font-size: 22px;
      margin-left: 15px;
      transition: all 100ms ease-in-out;
      &.disabled {
        color: lighten(@blue, 20%);
        cursor: not-allowed;
      }
    }
  }
</style>
